import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRequest,
  getRequestWithApiKey,
  getRequestWithParamsAndApiKey,
} from "../../services/API";
import { isEmpty } from "../../services/validation";

const FETCH_FORM_CARRIER = "fetchCarriers";
const FETCH_ALL_FORM = "fetchAllForms";
const FETCH_BUISNESS_POLICY = "fetchPolicies";

export const fetchCarriers = createAsyncThunk(
  FETCH_FORM_CARRIER,
  async ({ language, isAdmin }) => {
    try {
      // Use API key for non-admin requests
      let carrierResult;
      if (isAdmin) {
        carrierResult = await getRequest(language, "carrier", isAdmin);
      } else {
        carrierResult = await getRequestWithApiKey(language, "carrier");
      }
      return carrierResult;
    } catch (error) {
      return JSON.parse(error.message);
    }
  }
);


export const fetchPolicies = createAsyncThunk(
  FETCH_BUISNESS_POLICY,
  async ({ language, isAdmin }, { rejectWithValue }) => {
    try {
      // Use API key for non-admin requests
      let policyResult;
      if (isAdmin) {
        policyResult = await getRequest(language, "policyService", isAdmin);
      } else {
        policyResult = await getRequestWithApiKey(language, "policyService");
      }
      return policyResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);


export const fetchAllForms = createAsyncThunk(
  FETCH_ALL_FORM,
  async ({ formsRequest }, { rejectWithValue }) => {
    const {
      language,
      page,
      limit,
      order,
      carrier_id,
      search_key,
      policy_service_id,
      isADA,
    } = formsRequest;

    try {
      let requestUrl = `?page=${page}&limit=${limit}&order=${order}`;

      if (!isEmpty(carrier_id)) {
        requestUrl = requestUrl + `&carrier_id=${carrier_id}`;
      }

      if (!isEmpty(search_key)) {
        requestUrl = requestUrl + `&search_key=${search_key}`;
      }

      if (!isEmpty(policy_service_id)) {
        requestUrl = requestUrl + `&policy_service_id=${policy_service_id}`;
      }

      if (!isEmpty(isADA)) {
        requestUrl = requestUrl + `&isADA=${isADA}`;
      }

      // Use API key for form requests (public endpoint)
      const fetchAllFormsResult = await getRequestWithParamsAndApiKey(
        language,
        "form",
        requestUrl
      );

      return fetchAllFormsResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
